import { JustpayClientEndpoint } from "@/views/loyalty/shared/endpoint_services/justpay-client-endpoint-service"

export class JustpayClient {
    constructor () {
        this.justpayClientEndpoint = new JustpayClientEndpoint()
    }

    async getClients () {
        const clients = await this.justpayClientEndpoint.getClients()
        return clients ? clients.map(client => {
            return { value: client.id, text: client.legal.name.short }
        }).sort((a, b) => {
            const nameA = a.text.toUpperCase() // ignore upper and lowercase
            const nameB = b.text.toUpperCase() // ignore upper and lowercase
            if (nameA < nameB) {
                return -1
            }
            if (nameA > nameB) {
                return 1
            }
            // names must be equal
            return 0
        }) : [{ value: '', text: '' }]
    }

    async getClient (clientNumber) {
        // const client = await this.justpayClientEndpoint.getClientEndpoint(clientId)
        const client = await this.getClientByNumber(clientNumber)
        return client ? { value: client.id, text: client.legal.name.short } : { value: '', text: '' }
    }

    async getClientByNumber (clientNumber) {
        const clients = await this.justpayClientEndpoint.getClients()
        return clients.find(f => f.number === clientNumber)
    }

    async getClientNumber (clientId) {
        const client = await this.justpayClientEndpoint.getClient(clientId)
        return client ? client.number : ''
    }

    async getClientShortName (clientId) {
        const client = await this.justpayClientEndpoint.getClient(clientId)
        console.log('getClientShortName client:', client)
        return client ? client.legal.name.short : ''
    }

    async getForFiltering () {
        const clients = await this.justpayClientEndpoint.getForFiltering()
        return clients.data.map(client => {
            return { value: client.value, text: client.text }
        })
    }
}
